module.exports = __webpack_public_path__ + "static/media/networking_specialisation_section.12f4a08e.gif";